<span class="svg__icon {{size && 'width-' + size}} {{verticalSize && 'height-' + verticalSize}}" [freInlineSvg]="svgPath"></span>
